var filters = angular.module('myp.filters',['ngAnimate']);

filters.filter('replace', function(){
    return function(text) {
        return text;
    };
});


// WEBPACK FOOTER //
// ./public/js/filters.js